"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryParams = getQueryParams;
exports.getAuthenticateUrl = getAuthenticateUrl;
exports.hasMultipleCodes = hasMultipleCodes;
exports.createRedirectUriForExternalCode = createRedirectUriForExternalCode;
var configuration_1 = require("./configuration");
var utils_1 = require("./utils");
var CURRENT_LANGUAGE_COOKIE = "tp-b2b-current-language";
function getQueryParams(url) {
    var returnValue = {};
    new URL(url).searchParams.forEach(function (value, key) {
        returnValue[key] = value;
    });
    return returnValue;
}
function getLocaleOrDefault(currentUrl) {
    var localeFromQuery = currentUrl.match(/[?|&]locale=(\w\w-\w\w)/);
    if (localeFromQuery) {
        return localeFromQuery[1].toString();
    }
    var localeFromCookie = (0, utils_1.getCookie)(CURRENT_LANGUAGE_COOKIE);
    return localeFromCookie || "en-US";
}
function getAuthenticateUrl(href, options) {
    var locale = getLocaleOrDefault(href);
    var authUrl = new URL(configuration_1.configuration.businessAuthentication.host);
    var currentURL = new URL(href);
    currentURL.searchParams.set("locale", locale);
    authUrl.searchParams.append("redirect_uri", currentURL.href);
    authUrl.searchParams.append("locale", locale);
    authUrl.searchParams.append("response_type", "code");
    authUrl.searchParams.append("cookie_domain", configuration_1.configuration.cookieDomain);
    if (options) {
        Object.keys(options).forEach(function (key) {
            authUrl.searchParams.append(key, options[key]);
        });
    }
    return authUrl.href;
}
function hasMultipleCodes(currentUrl) {
    return new URL(currentUrl).searchParams.getAll("code").length > 1;
}
function createRedirectUriForExternalCode(queryParams, currentUrl) {
    var url = new URL(currentUrl);
    var pairs = url.search.substring(1).split("&");
    var newSearch = pairs.filter(function (pair) {
        var splits = pair.split("=");
        return splits[1] !== queryParams.code;
    });
    return "".concat(url.protocol, "//").concat(url.host).concat(url.pathname).concat(newSearch.length === 0 ? "" : "?".concat(newSearch.join("&")));
}
//# sourceMappingURL=urls.js.map